import React, { useState, useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useExperiment } from '@printdeal/feature-management/react';
import { Button, Grid, LinkAsButton } from '@printdeal/ui-library';
import ExploreDesignTemplatesModal from './exploreDesignTemplatesModal';
import { dispatchDataLayerEventOnClick } from '../../helpers/dataLayerHelpers/DesignTemplateDataLayerHelper';

interface ExploreDesignTemplateButtonProps {
  isButton?: boolean;
  className?: string;
  withLine?: boolean;
  label: 'nav_link' | 'home_button' | 'pdp_button' | 'category_link';
}

export const ExploreDesignTemplateButton = ({
  isButton,
  className,
  label,
  withLine = true,
}: ExploreDesignTemplateButtonProps) => {
  const intl = useIntl();
  const {
    experiment: experimentExp1452,
    isInitialized: isExp1452Initialized,
  } = useExperiment('exp1452_pdt_offer_templates_startpoint');
  const showDesignTemplateButton = isExp1452Initialized && experimentExp1452.variation === 'variant';

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = useCallback(() => {
    dispatchDataLayerEventOnClick({ category: 'EXP1452', label });
    setIsModalOpen(true);
  }, []);

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const buttonText = intl.formatMessage({
    id: 'general.button.exploreDesignTemplates',
    defaultMessage: 'Explore Design Templates',
  });

  return showDesignTemplateButton && (
    <Grid.Item>
      {isButton ? (
        <>
          {withLine && <hr className="pd-my-4" />}
          <div className={className}>
            <Button
              className={className}
              variant="secondary"
              iconBefore="photo-edit"
              onClick={handleOpenModal}
            >
              {buttonText}
            </Button>
          </div>
        </>
      ) : (
        <LinkAsButton
          onClick={handleOpenModal}
          variant="secondary"
          iconBefore="photo-edit"
          className={className}
        >
          {buttonText}
        </LinkAsButton>
      )}
      {isModalOpen && (
      <ExploreDesignTemplatesModal
        handleCloseModal={handleCloseModal}
      />
      )}
    </Grid.Item>
  );
};
